import { OnChanges, Component, Input, ComponentFactoryResolver, SimpleChanges, ViewContainerRef, ViewChild, output, AfterViewInit } from '@angular/core';
import { ComponentLocator } from '../component-locator';
import { WingViewModelTypeInspector } from '../../view-models/decorators/wing-view-model-type.decorator';
import { LoaderComponent } from '../shared/loader/loader.component';
import { AsyncPipe } from '@angular/common';
import { WingViewComponentInterface, WingViewModelInterface } from '@nts/std/interfaces';

@Component({
    selector: 'nts-wing-container',
    templateUrl: './wing-container.component.html',
    styleUrls: ['./wing-container.component.scss'],
    standalone: true,
    imports: [
        LoaderComponent,
        AsyncPipe
    ]
})
export class WingContainerComponent implements OnChanges, AfterViewInit {
    @ViewChild('wingPlaceHolder', { read: ViewContainerRef, static: true }) wingPlaceHolder: ViewContainerRef;

    @Input() wingViewModel!: WingViewModelInterface;

    readonly viewReady = output<void>();
    isViewReady = false;

    isCollapsed!: boolean;

    private _componentInstance: any = null;

    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
        protected componentLocator: ComponentLocator) {
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes['wingViewModel'] && this.wingViewModel !== undefined) {
            this.wingPlaceHolder.clear();

            // Composition e DI dinamica
            this.clearComponentInstance();

            const viewModelType = WingViewModelTypeInspector.getValue(this.wingViewModel);
            const componentType = this.componentLocator.getComponentType(viewModelType);
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
            const componentRef = this.wingPlaceHolder.createComponent(componentFactory);
            this._componentInstance = componentRef.instance as WingViewComponentInterface;
            this._componentInstance.wingViewModel = this.wingViewModel;
            await this._componentInstance.initialize();
            await (this._componentInstance.wingViewModel as WingViewModelInterface)?.postInit();
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.#emitViewReady();
        }, 0);
    }

    clearComponentInstance() {
        if (this._componentInstance != null) {
            this.wingPlaceHolder.remove(this.wingPlaceHolder.indexOf(this._componentInstance));
        }
    }

    #emitViewReady(): void {
        this.isViewReady = true;
        this.viewReady.emit();
    }
}
